import { magicNumbers } from 'utils';

export const instagramFiltersInitialState = {
  contentTagFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'contentTagFilter',
    translateKey: 'filter:contentsTag',
  },
  wordCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'wordCloudFilter',
    translateKey: 'filter:wordCloud',
  },
  seenStatusFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both',
    componentName: 'seenStatusFilter',
    translateKey: 'filter:seenStatus',
  },
  hashtagCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'hashtagCloudFilter',
    translateKey: 'filter:hashtagCloud',
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'instagram',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
  },
  advertFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjectValues: {
      min: 0,
      max: 1,
      active: false,
    },
    componentName: 'advertFilter',
    translateKey: 'filter:advertLevel',
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
      },
      like: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:likeCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
      },
      comment: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:commentCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:contentBasedOn',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'instagram',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
  },
  ageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'ageFilter',
    translateKey: 'filter:ageRange',
  },
  genderFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'genderFilter',
    translateKey: 'filter:gender',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    platform: 'instagram',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    selectedValue: '',
    filterType: 'include',
    hasIncludeExclude: true,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'instagram',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
